import revealOnScroll from "../utils/revealOnScroll"

class Testimonials {
	constructor(selector = ".testimonial-card") {
		this.cards = Array.from(document.querySelectorAll(selector))

		this.init()
	}

	init() {
		if (!this.cards.length) {
			return
		}

		revealOnScroll(this.cards, {
			stagger: 110,
			visibleClass: "is-visible",
			observerOptions: { threshold: 0.12 }
		})
	}
}

export default Testimonials
